<template>
  <v-row no-gutters justify="space-between" class="mb-5">
    <LimitList v-model="currentLimit" :limit-list="limitList" class="order-1 order-sm-0" />
    <v-col cols="12" sm="6" class="d-flex justify-center justify-sm-end">
      <v-pagination
        v-model="page"
        :length="maxPages"
        :show-first-last-page="props.showFirstLastPage"
        :total-visible="props.totalVisible"
        density="compact"
        active-color="#ED1C24"
      >
        <template v-if="isDesktop" #prev="prevProps">
          <v-btn
            variant="text"
            class="v-btn prev-next-button"
            :class="{ 'v-btn--disabled': prevProps.disabled }"
            :disabled="prevProps.disabled"
            :aria-label="$t('label.previous')"
            :aria-disabled="prevProps.disabled"
          >
            <span class="v-btn__overlay" />
            <span class="v-btn__underlay" />
            <span class="v-btn__content" @click="() => prevProps.disabled || page--">
              {{ $t('label.previous') }}
            </span>
          </v-btn>
        </template>
        <template v-if="isDesktop" #next="nextProps">
          <v-btn
            variant="text"
            class="v-btn prev-next-button"
            :class="{ 'v-btn--disabled': nextProps.disabled }"
            :disabled="nextProps.disabled"
            :aria-label="$t('label.next')"
            :aria-disabled="nextProps.disabled"
          >
            <span class="v-btn__overlay" />
            <span class="v-btn__underlay" />
            <span class="v-btn__content" @click="() => nextProps.disabled || page++">
              {{ $t('label.next') }}
            </span>
          </v-btn>
        </template>
      </v-pagination>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import LimitList from '@/components/FamiliesList/LimitList.vue'
import { useVuetifyBreakpoints } from '@/composables/useVuetifyBreakpoints'
import { computed, defineProps, ref, watch, withDefaults } from 'vue'
// @ts-expect-error: Importing Vuex store
import { useStore } from 'vuex'

type Props = {
  itemsAmount: number
  showFirstLastPage?: boolean
  totalVisible?: number
}

const props = withDefaults(defineProps<Props>(), {
  showFirstLastPage: true,
  totalVisible: 6
})
const store = useStore()

const page = ref<number>(1)
const limitList = [20, 50, 100] as const satisfies number[]

const currentLimit = ref<(typeof limitList)[number]>(limitList[0])

const maxPages = computed<number>(() => Math.ceil(props.itemsAmount / currentLimit.value))

watch(page, (newPage) => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
  store.commit('families/setFilter', { offset: newPage })
})

watch(currentLimit, () => {
  page.value = 1 // Reset page when limit changes
  store.commit('families/setFilter', { limit: currentLimit.value })
})

const filter = computed(() => store.getters['families/getFilter'])
watch(
  filter,
  (newFilter) => {
    page.value = newFilter.offset ?? 1
    currentLimit.value = newFilter.limit ?? limitList[0]
  },
  { immediate: true, deep: true }
)

const breakpoints = useVuetifyBreakpoints()

const isDesktop = breakpoints.greaterOrEqual('md')
</script>
<style lang="scss">
.v-pagination__list {
  align-items: center;

  .prev-next-button {
    text-transform: none;
    letter-spacing: initial;
    height: 28px;
    padding: 0 8px;
    font-size: 1rem;

    &.v-btn {
      width: auto;
    }
  }
}
</style>
